import { render, staticRenderFns } from "./btn-layout-align.vue?vue&type=template&id=283ceb44&scoped=true"
import script from "./btn-layout-align.vue?vue&type=script&lang=js"
export * from "./btn-layout-align.vue?vue&type=script&lang=js"
import style0 from "./btn-layout-align.vue?vue&type=style&index=0&id=283ceb44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ceb44",
  null
  
)

export default component.exports